import React from 'react';
import { motion } from 'framer-motion';
import './index.css';
import { Mail, Linkedin, Github } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="section section-alt">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Get In Touch
        </motion.h2>
        <div className="contact-content">
          <motion.p
            className="contact-description"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            I'm open to software and hardware roles, research collaborations, and
            interesting side projects. The fastest way to reach me is email — I read
            everything and reply within a day or two.
          </motion.p>
          <div className="contact-links">
            <motion.a
              href="mailto:anubhavchoudhery@gmail.com"
              className="contact-link"
              whileHover={{ scale: 1.05, y: -5 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
            >
              <Mail size={24} />
              <span>Email</span>
            </motion.a>
            <motion.a
              href="https://linkedin.com/in/anubhav-ch"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
              whileHover={{ scale: 1.05, y: -5 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
            >
              <Linkedin size={24} />
              <span>LinkedIn</span>
            </motion.a>
            <motion.a
              href="https://github.com/AnubhavChoudhery"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
              whileHover={{ scale: 1.05, y: -5 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5 }}
            >
              <Github size={24} />
              <span>GitHub</span>
            </motion.a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
